<template>

<div>

<el-row type="flex" class="row-bg" justify="center">
  <el-col :xs="20" :span="16">
  <el-menu class="el-menu-demo" mode="horizontal">
  <el-menu-item index="1"><a href="/">Home</a></el-menu-item>
  <el-menu-item index="2"><a href="/apps">Apps</a></el-menu-item>
  <!-- <el-menu-item index="3"><a href="/about">About</a></el-menu-item> -->
  <el-menu-item index="4"><a href="/terms">Terms</a></el-menu-item>
  <el-menu-item index="5"><a href="/privacy">Privacy</a></el-menu-item>
</el-menu>

<div class="line"></div>
</el-col>
</el-row>


<h3> Hi! Welcome to Biographics. </h3>

<p> Biographics is owned and operated by <a href='https://marcio.digital/'> Marcio Cabral </a>.</p>

<p> At Biographics we build <a href='/apps'>iOS Apps</a> </p>


</div>

</template>

<script>
export default {
  name: 'MainPage',
  data () {
    return {
      activeName: 'airporty'
    }
  },
  methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/MainPage.vue